import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import { combineReducers } from "redux";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER
} from "redux-persist";
import storage from 'redux-persist/lib/storage'
import thunk from 'redux-thunk'
import counterReducer from '../components/counter/counterSlice';
import commonReducer from './commonReduxSlice';
import authSliceReducer from '../components/Auth/authSlice';
import addRoleSliceReducer from '../components/AddRole/addRoleSlice';
import userRolesSliceReducer from '../components/UserRoles/userRoleSlice';
import departmentsSliceReducer from '../components/Department/departmentSlice';
import addBranchSliceReducer from '../components/AddBranch/addBranchSlice';
import viewEditBranchSliceReducer from '../components/ViewEditBranch/viewEditBranchSlice';
import addOfficeSliceReducer from '../components/AddOffice/addOfficeSlice';
import viewEditOfficeSliceReducer from '../components/ViewEditOffice/viewEditOfficeSlice';
import addDirectorateSliceReducer from '../components/AddDirectorate/addDirectorateSlice';
import ViewEditDirectorateSliceReducer from '../components/ViewEditDirectorate/ViewEditDirectorateSlice';
import adddepartmentSliceReducer from '../components/AddDepartment/addDepartmentSlice';
import editdepartmentSliceReducer from '../components/EditDepartment/editDepartmentSlice';
import viewdepartmentSliceReducer from '../components/ViewDepartment/viewDepartmentSlice';
import editroleSliceReducer from '../components/EditRole/editRoleSlice';
import ManageUserSlice from '../components/ManageUser/manageuserSlice';
import addUserSliceReducer from '../components/AddUser/addUserSlice';
import editUserSliceReducer from '../components/EditUser/editUserSlice';
import SubAdminSlice from '../components/SubAdmin/subadminSlice';
import AddSubAdminSlice from '../components/AddSubAdmin/addSubAdminSlice';
import editSubAdminSlice from '../components/EditSubAdmin/editSubAdminSlice';
import ViewSubAdmin from '../components/ViewSubAdmin/viewSubAdminSlice';
import viewAlluserSlice from '../components/ViewAllUser/viewalluserSlice';
import viewUserSliceSlice from '../components/ViewUser/viewUserSlice';

import viewtemplateSlice from '../components/Templates/templateSlice';
import ViewProcess from '../components/ViewTemplates/viewTemplateSlice';

import newTemplateSlice from '../components/NewTemplate/newTemplateSlice';
import editTemplateSlice from '../components/EditTemplate/editTemplateSlice';
import editTemplateDraftSlice from '../components/EditTemplateDraft/editTemplateDraftSlice';

import resetPasswordSlice from '../components/ResetPassword/resetPasswordSlice';
import ViewDashboardSlice from '../components/Dashboard/Admin/AdminDashboardSlice';
import DistributionListSlice from '../components/DistributionList/DistributionListSlice';

import FrontViewAllUser from '../components/ViewAllUser/Front/viewalluserSlice';
import ClerkDashboardSlice from '../components/ClerkPanel/Dashboard/Clerk/ClerkDashboardSlice';
import AddDocumentSlice from '../components/ClerkPanel/AddDocument/AddDocumentSlice';
import EditPasswordSlice from '../components/EditPassword/EditPasswordSlice';

import MinutesStageApprovedSlice from '../components/MinuteStageApprover/MinutesStageApprovedSlice';
import DocumentSeenStampSlice from '../components/DocumentSeenStamp/DocumentSeenStampSlice';
import DocumentHighlightsSlice from '../components/DocumentVerification/DocumentHighlightsSlice';
import DocumentCommentsSlice from '../components/DocumentComments/DocumentCommentsSlice';
import DocumentSignatureSlice from '../components/DocumentSignature/DocumentSignatureSlice';

import ViewAllNotificationSlice from '../components/ClerkPanel/Notification/ViewAllNotificationSlice';
import ClerkAllProcessSlice from '../components/ClerkPanel/Process/ClerkAllProcessSlice';

import ChdviewtemplateSlice from '../components/CHDPanel/Templates/templateSlice';
import ChdNewTemplateSlice from '../components/CHDPanel/NewTemplate/newTemplateSlice';
import ChdeditTemplateSlice from '../components/CHDPanel/EditTemplate/editTemplateSlice';
import ChdeditTemplateDraftSlice from '../components/CHDPanel/EditTemplateDraft/editTemplateDraftSlice';
import ChdViewProcess from '../components/CHDPanel/ViewTemplates/viewTemplateSlice';
import ChdViewAlluserSlice from '../components/CHDPanel/ViewAllUser/viewalluserSlice';

import ClerkViewAllProcessSlice from '../components/ClerkPanel/ViewAllProcess/ClerkAllProcessSlice';
import ViewNotificationSlice from '../components/ViewNotification/ViewNotificationSlice';

import AdminAllProcessSlice from '../components/Process/AdminAllProcessSlice';
import AdminViewProcessSlice from '../components/ViewAllProcess/AdminViewProcessSlice';

import ChdDashboardSlice from '../components/CHDPanel/Dashboard/component/ChdDashboardSlice';
import ChdAddDocumentSlice from '../components/CHDPanel/AddDocument/ChdAddDocumentSlice';
import ChdAllProcessSlice from '../components/CHDPanel/Process/ChdAllProcessSlice';
import ChdViewProcessSlice from '../components/CHDPanel/ViewAllProcess/ChdViewProcessSlice';
import ChdViewAllNotificationSlice from '../components/CHDPanel/Notification/ChdViewAllNotificationSlice';
import ChdTakeActionNotySlice from '../components/CHDPanel/TakeActionNotification/ChdTakeActionNotySlice';

import DDsAndAdsDashboardSlice from '../components/DDADPanel/Dashboard/component/DDsAndAdsDashboardSlice';
import DDsAndAdsAddDocumentSlice from '../components/DDADPanel/AddDocument/DDsAndAdsAddDocumentSlice';
import DDsAndAdsAllProcessSlice from '../components/DDADPanel/Process/DDsAndAdsAllProcessSlice';
import DDsAndAdsViewProcessSlice from '../components/DDADPanel/ViewAllProcess/DDsAndAdsViewProcessSlice';
import DDsAndAdsViewAlluserSlice from '../components/DDADPanel/ViewAllUser/DDsAndAdsViewAlluserSlice';
import DDsAndAdsViewAllNotificationSlice from '../components/DDADPanel/Notification/DDsAndAdsViewAllNotificationSlice';
import DDsAndAdsTakeActionNotificationSlice from '../components/DDADPanel/TakeActionNotification/DDsAndAdsTakeActionNotySlice';

import ModifySignatureSlice from '../components/ModifySignature/ModifySignatureSlice';
import ChdAddMultipleProcessDocumentSlice from '../components/CHDPanel/AddMultipleProcessDocument/ChdAddMultipleProcessDocumentSlice';
import ManageActivitySlice from '../components/ManageActivity/ManageActivitySlice';

import DocumentEditorSlice from '../components/DocumentEditor/DocumentEditorSlice';
import DocumentEditHistroySlice from '../components/DocumentEditHistory/DocumentEditHistorySlice';

import CommonDocumentSlice from '../components/CollaborationDocumentEditor/CommonDocumentSlice';
import CollaborateDocumentSlice from '../components/ClerkPanel/CollaborateDocument/CollaborateDocumentSlice';

import ClerkAddMultipleProcessDocumentSlice from '../components/ClerkPanel/AddMultipleProcessDocument/ClerkAddMultipleProcessDocumentSlice';
import DdAdsAddMultipleProcessDocumentSlice from '../components/DDADPanel/AddMultipleProcessDocument/DdAdsAddMultipleProcessDocumentSlice'

import ChdCollaborateDocumentSlice from '../components/CHDPanel/CollaborateDocument/ChdCollaborateDocumentSlice';
import adsCollaborateDocumentSlice from '../components/DDADPanel/CollaborateDocument/adsCollaborateDocumentSlice';

const rootReducer = combineReducers({
  common: commonReducer,
  auth: authSliceReducer,
  resetPassword: resetPasswordSlice,
  userEditPassword: EditPasswordSlice,
  viewAdminDashboard: ViewDashboardSlice,
  viewClerkDashboard: ClerkDashboardSlice,
  distributionList: DistributionListSlice,
  addtemplate: newTemplateSlice,
  edittemplate: editTemplateSlice,
  edittemplatedraft: editTemplateDraftSlice,
  viewtemplate: viewtemplateSlice,
  viewAllProcess: ViewProcess,
  departments: departmentsSliceReducer,
  addbranch: addBranchSliceReducer,
  vieweditbranch: viewEditBranchSliceReducer,
  addoffice: addOfficeSliceReducer,
  vieweditoffice: viewEditOfficeSliceReducer,
  adddirectorate: addDirectorateSliceReducer,
  vieweditdirectorate: ViewEditDirectorateSliceReducer,
  adddepartment: adddepartmentSliceReducer,
  editdepartment: editdepartmentSliceReducer,
  viewdepartment: viewdepartmentSliceReducer,
  addrole: addRoleSliceReducer,
  userroles: userRolesSliceReducer,
  editrole: editroleSliceReducer,
  manageusers: ManageUserSlice,
  viewalluser: viewAlluserSlice,
  adduser: addUserSliceReducer,
  edituser: editUserSliceReducer,
  viewuser: viewUserSliceSlice,
  subadmin: SubAdminSlice,
  addsubadmin: AddSubAdminSlice,
  editsubadmin: editSubAdminSlice,
  viewsubadmin: ViewSubAdmin,
  frontviewallusers: FrontViewAllUser,
  adddocument: AddDocumentSlice,
  minutestageapprover: MinutesStageApprovedSlice,
  documentseenstamps: DocumentSeenStampSlice,
  documenthighlights: DocumentHighlightsSlice,
  documentcomments: DocumentCommentsSlice,
  documentsignature: DocumentSignatureSlice,
  viewallnotification: ViewAllNotificationSlice,
  clerkAllProcess: ClerkAllProcessSlice,
  chdviewtemplate: ChdviewtemplateSlice,
  chdedittemplate: ChdeditTemplateSlice,
  chdedittemplatedraft: ChdeditTemplateDraftSlice,
  chdviewAllProcess: ChdViewProcess,
  chdaddtemplate: ChdNewTemplateSlice,
  chdviewallusers: ChdViewAlluserSlice,
  Clerkviewallprocess: ClerkViewAllProcessSlice,
  viewnotification: ViewNotificationSlice,
  adminAllProcess: AdminAllProcessSlice,
  adminViewProcess: AdminViewProcessSlice,
  viewChdDashboard: ChdDashboardSlice,
  Chdadddocument: ChdAddDocumentSlice,
  ChdAllProcess: ChdAllProcessSlice,
  chdviewprocess: ChdViewProcessSlice,
  chdviewallnotification: ChdViewAllNotificationSlice,
  ChdTakeActionNotification: ChdTakeActionNotySlice,
  viewDDsAndAdsDashboard: DDsAndAdsDashboardSlice,
  DDsAndAdsadddocument: DDsAndAdsAddDocumentSlice,
  DDsAndAdsAllProcess: DDsAndAdsAllProcessSlice,
  DDsAndAdsviewprocess: DDsAndAdsViewProcessSlice,
  DDsAndAdsViewAlluser: DDsAndAdsViewAlluserSlice,
  DDsAndAdsviewallnotification: DDsAndAdsViewAllNotificationSlice,
  DDsAndAdsTakeActionNotification: DDsAndAdsTakeActionNotificationSlice,
  viewsignaturelist: ModifySignatureSlice,
  Chdaddmultipleprocessdocument: ChdAddMultipleProcessDocumentSlice,
  manageactivitylog: ManageActivitySlice,
  documenteditor: DocumentEditorSlice,
  documentedithistroy: DocumentEditHistroySlice,
  counter: counterReducer,
  commonDocument: CommonDocumentSlice,
  clerkCollaborateDoc: CollaborateDocumentSlice,
  chdCollaborateDoc: ChdCollaborateDocumentSlice,
  adsCollaborateDoc: adsCollaborateDocumentSlice,
  Clerkaddmultipleprocessdocument: ClerkAddMultipleProcessDocumentSlice,
  DdAdsaddmultipleprocessdocument: DdAdsAddMultipleProcessDocumentSlice,
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: [
    'common', 'auth'
  ],
  // Blacklist (Don't Save Specific Reducers)
  blacklist: [],
};


const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: [thunk]
});

export default store;

// let store = configureStore({
//   reducer: persistedReducer,
//   middleware: getDefaultMiddleware({
//     immutableCheck: false,
//     serializableCheck: {
//       ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
//     }
//   })
// });

// let persistor = persistStore(store);

// export {
//   store,
//   persistor,
// };

// export const store = configureStore({
//   reducer: {
//     counter: counterReducer,
//   },
// });
